module.exports = __webpack_public_path__ + "static/media/abhranilbhattacharjee.35a7617e.png";